import { BaseModel } from '~/models/baseModel';

export class BulletinBoardSummaryModel extends BaseModel {
    public lots:number;
    public bales:number;
}
